// This script creates an iframe which then loads the actual webchat.
import './polyfill';
import './css';
import iframesPromise from './iframes';
import isMobile from './isMobile';
import configPromise from './config';
import apiPromise from './api';
import visibilityChangeHandler from './visibilityChangeHandler';
import { CHAT_STARTS_OPEN_LOCAL_STORAGE_KEY } from './constants';

const sendUserData = userData => window.Ambit('sendUserData', userData);

Promise.all([configPromise, iframesPromise, apiPromise]).then(([config, iframes, api]) => {
  // Listen for any messages from the webchat JS
  window.addEventListener('message', e => {
    if (!e.data || !(e.data.source === 'ambitChatLauncher' || e.data.source === 'ambitChatPanel')) {
      return;
    }

    const message = e.data;

    if (message.type === 'unreadMessages') {
      const { count } = message;
      api.unreadMessages(count);

      // Dispatch event to launcher iframe if present
      if (iframes.launcherFrame) {
        iframes.launcherFrame.contentWindow.postMessage({ type: 'unreadMessages', count }, '*');
      }
    }

    if (message.type === 'clearChatPanel') {
      api.flushApiQueue();
      api.setWebChatReady(false);
      api.replayHistoricalCalls();
    }

    if (message.type === 'sendProactiveMessage') {
      api.setWebChatReady(true);

      // Send down user data in the config object
      if (config.userData) {
        sendUserData(config.userData);
      }

      window.Ambit('sendMessage', message.text);
    }

    if (message.type === 'activity') {
      if (message.data.name === 'synapseBotEvent') {
        api.botEvent(message.data.value);
      }
      api.activity(message.data);
    }

    if (message.type === 'toggleWebChatOpenState') {
      visibilityChangeHandler();
    } else if (message.type === 'webchatReactLoaded') {
      // Send down user data in the config object
      if (config.userData) {
        sendUserData(config.userData);
      }

      const startOpen =
        (window.localStorage.getItem(CHAT_STARTS_OPEN_LOCAL_STORAGE_KEY) === 'true' &&
          config.rememberConversation &&
          config.enableAutoOpen) ||
        config.inline;

      if (startOpen && (!isMobile() || config.enableAutoOpenOnMobile)) {
        visibilityChangeHandler();
      }

      // We're able to deal with visibility change requests via the API now, so handle any which
      // have been queued
      api.flushApiQueue(['toggleChatPanelVisible', 'openChatPanel', 'closeChatPanel']);
    } else if (message.type === 'webChatReady') {
      api.flushApiQueue();
      api.setWebChatReady(true);
    }
  });

  // Listen for resize events and inform the iframe
  window.addEventListener('resize', () => {
    iframes.chatWindowFrame.contentWindow.postMessage(
      { type: 'updateIsMobile', isMobile: isMobile() },
      '*'
    );
  });
});



// WEBPACK FOOTER //
// ./src/initialiser/init.js